var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 30,
    height: 30,
    rx: 2,
    fill: "#446CD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4758 25.3738L27.8904 22.6796H25.2968V20.932C25.2968 20.1948 25.6584 19.4757 26.8201 19.4757H28V17.182C28 17.182 26.9297 17 25.9068 17C23.7699 17 22.3744 18.2906 22.3744 20.6262V22.6796H20V25.3738H22.3744V31.8871C22.8511 31.9618 23.3388 32 23.8356 32C24.3324 32 24.8201 31.9618 25.2968 31.8871V25.3738H27.4758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.55817857999ee03a67b65162d0a77bd5.svg";
export { ForwardRef as ReactComponent };